const motionIsReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const revealTargets = document.querySelectorAll('[data-mrp-reveal]');

if (revealTargets.length) {
  document.documentElement.classList.add('mrp-motion-ready');

  if (motionIsReduced || !('IntersectionObserver' in window)) {
    revealTargets.forEach((target) => target.classList.add('is-visible'));
  } else {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 },
    );

    revealTargets.forEach((target) => revealObserver.observe(target));
  }
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-mrp-cookie-preferences]');
  if (!trigger) return;
  event.preventDefault();

  if (typeof privacyBanner !== 'undefined' && typeof privacyBanner.showPreferences === 'function') {
    privacyBanner.showPreferences();
    return;
  }

  document.querySelector('#shopify-pc__banner .shopify-pc__banner__btn-manage-prefs')?.click();
});

const updatePrivacyBannerLabels = () => {
  const acceptButton = document.querySelector('#shopify-pc__banner .shopify-pc__banner__btn-accept');
  if (acceptButton && acceptButton.textContent.trim() === 'Akzeptieren') {
    acceptButton.textContent = 'Alle akzeptieren';
  }
};

updatePrivacyBannerLabels();
new MutationObserver(updatePrivacyBannerLabels).observe(document.body, { childList: true, subtree: true });
